<template>
  <div class="ivan-wf-shell">
    <div
      v-if="showBar"
      data-id="wfToolBar"
      class="form-inline"
      style="display: block;"
    >
      <div style="padding: 5px; min-height: 45px;" class="bg-info">
        <div style="display: inline-block;">
          <span v-if="showAttach" style="display: inline-block; margin-right: 4px;">
            <button class="btn btn-info hidden-xs" type="button" title="上传附件" @click="$emit('attach')">
              <i class="fa fa-upload" />
              <span>附件</span>
            </button>
          </span>

          <span v-if="showSave" style="display: inline-block; margin-right: 4px;">
            <button class="btn btn-success hidden-xs" type="button" :disabled="saving" @click="$emit('save')">
              <i class="fa fa-save" />
              <span>暂存</span>
            </button>
          </span>

          <span v-if="showBack" style="display: inline-block; margin-right: 4px;">
            <button class="btn btn-danger hidden-xs" type="button" :disabled="backing" @click="$emit('back')">
              <i class="fa fa-reply" />
              <span>退回</span>
            </button>
          </span>

          <!-- 提交 + 下一节点（对齐 Ivan ToolBar） -->
          <span v-if="showSubmit" class="btn-group has-feedback hidden-xs" style="display: inline-block; margin-right: 4px; vertical-align: middle;">
            <button class="btn btn-primary" type="button" :disabled="submitting" @click="$emit('submit')">
              <i class="fa fa-send" />
              <span>提交</span>
            </button>
            <span v-if="nextNodeLabel || showNextNode" class="input-group" style="display: inline-flex; vertical-align: middle; margin-left: 2px;">
              <select
                v-if="nextNodeLabel"
                class="form-control input-sm"
                style="min-width: 100px; display: inline-block; width: auto; height: 34px;"
                disabled
              >
                <option>{{ nextNodeLabel }}</option>
              </select>
              <slot name="next-node" />
            </span>
          </span>

          <slot name="extra-actions" />
        </div>
      </div>
    </div>
    <div class="ivan-wf-body" style="margin-top: 8px;">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'WfCaseShell',
  props: {
    showBar: { type: Boolean, default: true },
    showAttach: { type: Boolean, default: false },
    showSave: { type: Boolean, default: true },
    showBack: { type: Boolean, default: false },
    showSubmit: { type: Boolean, default: true },
    /** 下一节点只读文案，如「委托审核」「采样任务管理」 */
    nextNodeLabel: { type: String, default: '' },
    showNextNode: { type: Boolean, default: true },
    saving: { type: Boolean, default: false },
    submitting: { type: Boolean, default: false },
    backing: { type: Boolean, default: false }
  }
}
</script>
